import {parseSdCode} from "./common"

const sdcode = parseSdCode()

export default {
  api: {
    // hostname: 'xit-server.sparcit.com',
    pathname: sdcode ? `/api/${sdcode}` : null,
  },
};



// WEBPACK FOOTER //
// ./src/config/production.js